import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import {
  // completeUserCreation,
  createUser,
  getRoles
} from "../../services/userservice";

import { getTenantFromUrl } from "../../helpers/http";

const CreateUserPopup = ({ onClose }) => {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [emailAddress, setEmailAddress] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [gender, setGender] = useState("");
  const [address, setAddress] = useState("");
  const [roleId, setRoleId] = useState("");
  const [loading, setLoading] = useState(false);
  // const [step, setStep] = useState(1);
  // const [password, setPassword] = useState("");
  // const [confirmPassword, setConfirmPassword] = useState("");

  const [roles, setRoles] = useState([]);

  const handleGenderChange = (e) => {
    setGender(e.target.value);
  };

  const handleRoleChange = (e) => {
    setRoleId(e.target.value);
  };

  const fetchRoles = async () => {
    try {
      const tenant = getTenantFromUrl();
      const res = await getRoles(tenant);
      setRoles(res.data);
    } catch (error) {
      if (error.response) {
        toast.error(error.response.data.message);
      }
    }
  };

  const handleNewUser = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const tenant = getTenantFromUrl();
      const res = await createUser({
        firstName,
        lastName,
        emailAddress,
        phoneNumber,
        gender,
        address,
        roleId,
      }, tenant);
      toast.success(res.message);
      // setStep(2);
      onClose();
    } catch (error) {
      if (error.response) {
        toast.error(error.response.data.message);
      }
    } finally {
      setLoading(false);
    }
  };

  // const handleCompleteUserCreation = async (e) => {
  //   e.preventDefault();
  //   if (password !== confirmPassword) {
  //     return toast.error("Passwords do not match");
  //   }
  //   setLoading(true);
  //   try {
  //     const res = await completeUserCreation({
  //       emailAddress,
  //       password,
  //     });
  //     toast.success(res.message);
  //     onClose();
  //   } catch (error) {
  //     if (error.response) {
  //       toast.error(error.response.data.message);
  //     }
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  useEffect(() => {
    fetchRoles();
  }, []);

  return (
    <div className="flex flex-col justify-center overflow-hidden absolute top-0 right-0 z-[1000] bg-white shadow rounded-md p-4">
      <div className="bg-white w-[350px] p-4 max-h-[90vh] overflow-y-auto">
        <div className="flex items-center justify-between">
          <h1 className="text-[20px] font-bold text-navy-blue">
            Create User
            {/* {step === 1 ? "Create User" : "Set Password"} */}
          </h1>
          <button
            className="flex justify-center text-[#E71D36] bg-[#E71D36]/20 rounded-3xl w-[30px] h-[30px]"
            onClick={onClose}
          >
            x
          </button>
        </div>

        <div className="flex flex-col items-center justify-center my-8">
          <svg
            width="134"
            height="134"
            viewBox="0 0 134 134"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="67" cy="67" r="67" fill="#F7F7F8" />
            <g opacity="0.7">
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M73.844 59.2073C73.898 59.2982 73.9925 59.3631 74.114 59.3631C77.354 59.3631 80 61.9083 80 65.0248V72.7382C80 75.8548 77.354 78.3999 74.114 78.3999H58.886C55.6325 78.3999 53 75.8548 53 72.7382V65.0248C53 61.9083 55.6325 59.3631 58.886 59.3631C58.994 59.3631 59.102 59.3111 59.1425 59.2073L59.2235 59.0514C59.2701 58.9571 59.3178 58.8602 59.3663 58.7618C59.7117 58.0613 60.0938 57.2864 60.3305 56.8309C60.9515 55.6622 62.0045 55.0129 63.314 54.9999H69.6725C70.982 55.0129 72.0485 55.6622 72.6695 56.8309C72.8821 57.24 73.2061 57.899 73.5184 58.5341C73.5828 58.6651 73.6467 58.795 73.709 58.9216L73.844 59.2073ZM72.8584 64.1935C72.8584 64.8427 73.3984 65.3622 74.0734 65.3622C74.7484 65.3622 75.302 64.8427 75.302 64.1935C75.302 63.5442 74.7484 63.0118 74.0734 63.0118C73.3984 63.0118 72.8584 63.5442 72.8584 64.1935ZM64.164 66.2064C64.7985 65.5961 65.622 65.2714 66.4995 65.2714C67.377 65.2714 68.2005 65.5961 68.8215 66.1934C69.4425 66.7908 69.78 67.5829 69.78 68.4269C69.7665 70.167 68.3085 71.5824 66.4995 71.5824C65.622 71.5824 64.7985 71.2578 64.1775 70.6605C63.5565 70.0631 63.219 69.271 63.219 68.4269V68.414C63.2055 67.5959 63.543 66.8037 64.164 66.2064ZM70.2393 72.0369C69.2808 72.9589 67.9578 73.5302 66.4998 73.5302C65.0823 73.5302 63.7593 72.9978 62.7468 72.0369C61.7478 71.063 61.1943 69.7904 61.1943 68.4269C61.1808 67.0764 61.7343 65.8038 62.7333 64.8299C63.7458 63.856 65.0823 63.3236 66.4998 63.3236C67.9173 63.3236 69.2538 63.856 70.2528 64.8169C71.2518 65.7908 71.8053 67.0764 71.8053 68.4269C71.7918 69.8423 71.1978 71.1149 70.2393 72.0369Z"
                fill="#030229"
              />
            </g>
          </svg>
        </div>
        <div className="flex flex-col mt-">
          {/* Step 1: Create User */}
          <form onSubmit={handleNewUser}>
            <div className="flex flex-col">
              <label htmlFor="firstName">First Name</label>
              <input
                type="text"
                id="firstName"
                onChange={(e) => setFirstName(e.target.value)}
                placeholder="John "
                className="h-[50px] bg-form-background p-2 mt-2 rounded-md text-navy-blue focus:outline-none"
                required
              />
            </div>

            <div className="flex flex-col mt-2">
              <label htmlFor="lastName">Last Name</label>
              <input
                type="text"
                id="lastName"
                onChange={(e) => setLastName(e.target.value)}
                placeholder="John "
                className="h-[50px] bg-form-background p-2 mt-2 rounded-md text-navy-blue focus:outline-none"
                required
              />
            </div>

            <div className="flex flex-col mt-2">
              <label htmlFor="emailAddress">Email</label>
              <input
                type="email"
                id="emailAddress"
                onChange={(e) => setEmailAddress(e.target.value)}
                placeholder="example@gmail.com"
                className="h-[50px] bg-form-background p-2 mt-2 rounded-md text-navy-blue focus:outline-none"
                required
              />
            </div>

            <div className="flex flex-col mt-2">
              <label htmlFor="phoneNumber">Phone Number</label>
              <input
                type="text"
                id="phoneNumber"
                onChange={(e) => setPhoneNumber(e.target.value)}
                placeholder="08033045559"
                className="h-[50px] bg-form-background p-2 mt-2 rounded-md text-navy-blue focus:outline-none"
                required
              />
            </div>

            <div className="flex flex-col mt-2">
              <label htmlFor="gender">Gender</label>
              <select
                className="h-[50px] bg-form-background p-2 mt-2 rounded-md text-navy-blue focus:outline-none"
                id="gender"
                name="gender"
                onChange={handleGenderChange}
                required
              >
                <option value="" selected disabled hidden>
                  Select Gender
                </option>
                <option value="male">Male</option>
                <option value="female">Female</option>
              </select>
            </div>

            <div className="flex flex-col mt-2">
              <label htmlFor="address">Address</label>
              <input
                type="text"
                id="address"
                onChange={(e) => setAddress(e.target.value)}
                placeholder="2239  Anthony Villlage"
                className="h-[50px] bg-form-background p-2 mt-2 rounded-md text-navy-blue focus:outline-none"
                required
              />
            </div>

            <div className="flex flex-col mt-2">
              <label htmlFor="user-role">User's Role</label>
              <select
                id="roleId"
                name="userRole"
                placeholder="Front Desk Officer"
                className="h-[50px] bg-form-background p-2 mt-2 rounded-md text-navy-blue focus:outline-none"
                onChange={handleRoleChange}
                required
              >
                <option value="">Select Role</option>
                {roles.map((role) => (
                  <option key={role.id} value={role.id}>
                    {role.name}
                  </option>
                ))}
              </select>
            </div>

            <div className="mt-6">
              <button
                className="w-full h-[50px] bg-primary text-white text-base font-semibold rounded-md disabled:opacity-50 disabled:cursor-not-allowed"
                type="submit"
                disabled={loading}
              >
                {loading ? "Creating..." : "Create User"}
              </button>
            </div>
          </form>

          {/* Step 2: Set Password (commented out) */}
          {/* <form onSubmit={handleCompleteUserCreation}>
            <div className="mb-4 text-sm text-gray-600">
              Set a password for <span className="font-semibold text-navy-blue">{emailAddress}</span> to complete the account setup.
            </div>
            <div className="flex flex-col">
              <label htmlFor="password">Password</label>
              <input
                type="password"
                id="password"
                onChange={(e) => setPassword(e.target.value)}
                placeholder="********"
                value={password}
                className="h-[50px] bg-form-background p-2 mt-2 rounded-md text-navy-blue focus:outline-none"
                required
              />
            </div>

            <div className="flex flex-col mt-4">
              <label htmlFor="confirmPassword">Confirm Password</label>
              <input
                type="password"
                id="confirmPassword"
                onChange={(e) => setConfirmPassword(e.target.value)}
                placeholder="********"
                value={confirmPassword}
                className="h-[50px] bg-form-background p-2 mt-2 rounded-md text-navy-blue focus:outline-none"
                required
              />
            </div>

            <div className="mt-8">
              <button
                className="w-full h-[50px] bg-primary text-white text-base font-semibold rounded-md disabled:opacity-50 disabled:cursor-not-allowed"
                type="submit"
                disabled={loading}
              >
                {loading ? "Completing..." : "Complete Creation"}
              </button>
            </div>
          </form> */}
        </div>
      </div>
    </div>
  );
};

export default CreateUserPopup;
